import { Observable } from 'rxjs';
import { AbstractScreenHandler, CRUDGenericService, TypeValidatorService } from 'attcei-bo-fw';
import { ScreenHandler } from 'attcei-bo-fw/lib/screen/interfaces/ScreenHandler';
import { Injectable } from '@angular/core';
import { PaginationState } from 'attcei-bo-fw/lib/classes/PaginationState';
import { Sort } from '@angular/material/sort';
import { PaginatedDTO } from 'attcei-bo-fw/lib/classes/dto/PaginatedDTO';
import { BasicLocalityDTO } from '../classes/dto/BasicLocalityDTO';
import { LocalityDTO } from '../classes/dto/LocalityDTO';

@Injectable({
    providedIn:'root'
})
export class LocalityScreenHandler extends AbstractScreenHandler<BasicLocalityDTO, LocalityDTO> implements ScreenHandler<BasicLocalityDTO, LocalityDTO>{
    constructor(private service: CRUDGenericService, typeValidator: TypeValidatorService){
        super(typeValidator);
    }
    
    loadListData(filter: any, paginationState: PaginationState, sort: Sort): Observable<PaginatedDTO<LocalityDTO>> {
        var url:string = this.getURL() + this.buildInvocationWithPaginationAndFilter(paginationState, filter, sort);
        return this.service.getDataList(url, true);
    }

    post(item: BasicLocalityDTO): Observable<LocalityDTO> {
        console.log('Recebi no post -> ', item);
        var dto: BasicLocalityDTO = super.parse(item);
        var res: Observable<LocalityDTO> = this.service.postData(this.getURL(),dto,true);
        console.log('result -> ', res);
        return res;
    }

    update(item: LocalityDTO):Observable<LocalityDTO> {
        console.log('Recebi no update -> ', item);
        var dto: LocalityDTO = super.parse(item);
        var res: Observable<LocalityDTO> = this.service.putData(this.getURL(), dto.id, dto, true);
        console.log('parsed -> ', res);
        return res;
    }

    delete(item: any):Observable<LocalityDTO> {
        return this.service.delete(this.getURL(), item.id, true);
    }

    getItem(id: number):Observable<LocalityDTO> {
        return this.service.getDataItem(this.getURL(), true, id);
    }

    getURL(): string {
        return 'locality';
    }

    getId(item: LocalityDTO): number {
        return item.id;
    }

    protected getUpdateTypeName(): string {
        return 'LocalityDTO';
    }

    protected getCreateTypeName(): string {
        return 'BasicLocalityDTO';
    }
}